import { render } from "./generic-select.vue?vue&type=template&id=4f6b4e34"
import script from "./generic-select.vue?vue&type=script&lang=js"
export * from "./generic-select.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__